// New passwords: 12 to 255 characters, the Cognito pool's minimum (TO-1696 16234). Every form that
// sets a password uses this; sign-in doesn't, so existing shorter passwords can still sign in (and
// are then sent to a reset).
export const NEW_PASSWORD_MIN_LENGTH = 12;
export const NEW_PASSWORD_MAX_LENGTH = 255;

export const isNewPasswordLength = (password) =>
    !!password && password.length >= NEW_PASSWORD_MIN_LENGTH && password.length <= NEW_PASSWORD_MAX_LENGTH;

export const NEW_PASSWORD_LENGTH_MESSAGE = `Your password must be between ${NEW_PASSWORD_MIN_LENGTH} and ${NEW_PASSWORD_MAX_LENGTH} characters long.`;
